import React from "react";
import { Form } from "antd";
import Utils from "utils";
import { formatMoney, formatterNumber } from "utils/helper";
import PropTypes from "prop-types";

const MediEditColumnTableCell = React.memo(
  ({
    required = false,
    editing = true,
    children,
    value,
    typeField,
    containerStyle,
    valuePropName = "value",
    customValue = null,
    shouldUpdate = null,
    formatter,
    disabled = false,
    ...rest
  }) => {
    const formatMap = {
      money: () => formatMoney(value),
      number: () => formatterNumber(value),
      datetime: () => Utils.formatDate(value),
      date: () => Utils.formatDate(value, true),
    };

    const formatValue = formatter
      ? formatter(value)
      : formatMap[typeField]?.() ?? value;

    if (!editing) {
      return (
        <span style={containerStyle}>
          {customValue ? customValue(value) : value ? formatValue : "—"}
        </span>
      );
    }

    if (shouldUpdate) {
      return (
        <Form.Item noStyle shouldUpdate={shouldUpdate}>
          {children}
        </Form.Item>
      );
    }

    return (
      <Form.Item
        rules={[{ required, message: "Bắt buộc!" }]}
        valuePropName={valuePropName}
        {...rest}
      >
        {React.cloneElement(children, { disabled })}
      </Form.Item>
    );
  }
);

MediEditColumnTableCell.propTypes = {
  required: PropTypes.bool,
  editing: PropTypes.bool,
  value: PropTypes.any,
  typeField: PropTypes.oneOf(["money", "number", "datetime", "date"]),
  containerStyle: PropTypes.object,
  valuePropName: PropTypes.string,
  customValue: PropTypes.func,
  shouldUpdate: PropTypes.func,
  formatter: PropTypes.func,
  disabled: PropTypes.bool,
};

export default MediEditColumnTableCell;
